import { render, staticRenderFns } from "./CreateUserObjectStore.vue?vue&type=template&id=0ef7cbac"
import script from "./CreateUserObjectStore.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateUserObjectStore.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports